import React, { Component } from "react";
import AssessmentCommon from './AssessmentCommon'

export class AssessmentHR extends Component {
  render() {
    return (
      <AssessmentCommon personType={0} />
    );
  }
}
